import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=df63388e&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=df63388e&prod&scoped=true&lang=less"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=df63388e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df63388e",
  null
  
)

export default component.exports